
import React, { useState } from 'react'
import { connect } from 'umi';

import Filter from '@/pages/dashboard/components/NewFilter';
import { setBtnPointLog } from '@/pages/dashboard/utils/utils';
import moment from 'moment';
/**
 * 
 * @param props 
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns 
 */
 const FILTER_PATH = '/realtime/nightingaleUsers/byCountryRegionZone';

const realtimeCountryFilter = (props:any) => {
  const {
    filterConfirm,
    filterReset,
    setFilterLoading,
    filterInit,
    timeZone = '+0',
    buttonLogConfig,
    openSticky = false,
    children,
    isHaveFilterSave=true
  } = props;

  // 设置inputList
  const inputList = [
    {
      type: 'singleDaily',
      key: 'singleDaily',
      default: moment().utcOffset(timeZone).format('YYYY-MM-DD'), // 根据时区设置默认值
    }
  ]
  const [filterValue, setFilterValue] = useState(null)

  const handleConfirm = (value: any) => {
    setFilterValue(value)
    filterConfirm?.({
      filterValue: value
    })
    setBtnPointLog(buttonLogConfig, value)
  }

  const handleReset = (value: any) => {
    setFilterValue(value)
    filterReset?.({
      filterValue:value
    })
    setBtnPointLog(buttonLogConfig, value, true)
  }

  const handleInit = (defaultValue: any) => {
    filterInit({filterValue:defaultValue})
    setFilterValue(defaultValue)
    setFilterLoading(false)
  }

  return (
  <Filter
    path={FILTER_PATH}
    openSticky={openSticky}
    latestDateType={''}
    value={filterValue}
    inputList={inputList}
    onInit={handleInit}
    onConfirm={handleConfirm}
    onReset={handleReset}
    isHaveFilterSave={isHaveFilterSave}
    >
      {children}
    </Filter>
  );
}

export default connect((state: any) => {
  return {
    gameCode: state.dashboard?.currentGame?.game_code,
  };
})(realtimeCountryFilter);